import { Form, Input, message } from 'antd';
import React, { useContext, useState } from 'react';
import { forgetPwd } from '@api/login';
import './login_interceptor.less';
import { useTranslation } from "react-i18next";
import Iconfont from "@components/iconfont/iconfont";
import { validatePassword } from "../../../util/utils";
import { debounce } from 'lodash';
import loginContext from "@components/login_context";
import { isPrefix, judge } from "@util/utils";
import H5LoginOptions from "./h5_login_options";
import H5FormError from "./h5_form_error";
import FormFieldError from "@components/form_field_error";
export default function SetNewPWD({
  setNewPWDVisible,
  newUcode,
  setForgetPWDVisible,
  setVisible,
  onWechatLogin,
}) {
  const [setPWDForm] = Form.useForm();
  const [fieldErrors, setFieldErrors] = useState({});
  const { t } = useTranslation()
  const { isPhone } = useContext(loginContext);
  const prefix = isPrefix();
  const isWx = judge();
  // Only unprefixed H5 inside WeChat uses the new login options layout.
  const showH5LoginOptions = isPhone && !prefix && isWx;
  const showLegacyLoginOptions = isPhone && !showH5LoginOptions;
  const updateFieldErrors = (fields = []) => {
    const errors = {};
    fields.forEach((field) => {
      const fieldName = Array.isArray(field.name)
        ? field.name.join(".")
        : field.name;
      if (fieldName) {
        errors[fieldName] = field.errors || [];
      }
    });
    setFieldErrors(errors);
  };
  const handleFinishFailed = ({ errorFields = [] } = {}) => {
    updateFieldErrors(errorFields);
  };
  const renderFieldError = (fieldName) => {
    const error = fieldErrors[fieldName]?.[0];
    // PC 端与 H5 端展示同样的异常提醒，PC 样式参考 pc-login-modal 的字段报错。
    if (!isPhone) return <FormFieldError error={error} />;
    return <H5FormError error={error} />;
  };
  const setPWDLoginFn = (e) => {
    e.stopPropagation();
    setPWDForm.submit();
  }
  const setPWDLogin = debounce(setPWDLoginFn,300)
  const switchToVerificationLogin = (e) => {
    e.stopPropagation();
    setNewPWDVisible(false);
    setForgetPWDVisible(false);
    setFieldErrors({});
    setVisible(true);
  };
  
  return (
    <div className={isPhone ? "boxMask phoneLoginMask" : "boxMask"}>
      <div
        className={`${isPhone ? 'boxContent phoneLoginContent' : 'boxContent'}${
          showH5LoginOptions ? ' h5-login-options-fixed' : ''
        }`}
      >
        <div className="text_title">
          <span>{t("设置新密码")}</span>
          {/* <div className="image-wrapper_4" onClick={(e) => {
            e.stopPropagation();
            setNewPWDVisible(false);
            setPWDForm.resetFields()
          }}>
            <img
              className="thumbnail_2"
              referrerPolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/pshr6c9dhlxm56xubgb1swhjj7c6idxbd7iac80a6e6-3d59-4dbf-a6fa-c87ab8e8531e"
            />
          </div> */}
        </div>
        <Form
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          form={setPWDForm}
          onFinish={data => {
            forgetPwd({
              phone: newUcode.phone,
              code: newUcode.code,
              unicode: newUcode.unicode,
              password: data.password
            }).then(res => {
              if (res.success) { 
                message.success(t(res.result))
                setTimeout(()=>{
                  setNewPWDVisible(false);
                  setPWDForm.resetFields();
                  location.reload();
                },1000)
              } else {
                message.error(t(res.errorInfo))
                setNewPWDVisible(false);
                setPWDForm.resetFields();
                setForgetPWDVisible(true)
              }
            })
          }}
          validateTrigger="onBlur"
          onFieldsChange={(_changedFields, allFields) =>
            updateFieldErrors(allFields)
          }
          onFinishFailed={handleFinishFailed}
        >
          <Form.Item
            name="password"
            type="password"
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("password")}
            rules={[
              {
                required: true,
                message: t('密码不能为空!')
              },
              {
                validator: validatePassword
              }
            ]}
          >
            <Input.Password
              placeholder={t("输入新密码")}
              autoComplete="new-password"
              iconRender={(val) =>
                !val ? (
                  <Iconfont
                    type={"icon-a-buxianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                ) : (
                  <Iconfont
                    type={"icon-a-xianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                )
              }
            />
          </Form.Item>
          <Form.Item
            name="confirm"
            dependencies={['password']}
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("confirm")}
            rules={[
              {
                required: true,
                message: t('请确认您的密码!'),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return validatePassword(_, value);
                  }
                  return Promise.reject(new Error(t('您输入的两个密码不匹配!')));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder={t("输入确认密码")}
              autoComplete="new-password"
              iconRender={(val) =>
                !val ? (
                  <Iconfont
                    type={"icon-a-buxianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                ) : (
                  <Iconfont
                    type={"icon-a-xianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                )
              }
            />
          </Form.Item>
        </Form>
        {showLegacyLoginOptions && (
          <div className="pwdlogin bjweb-flex-space">
            <span
              className="validateText cursor"
              onClick={switchToVerificationLogin}
            >
              {t("验证码登录")}
            </span>
          </div>
        )}
        <div className="text-wrapper_4" onClick={setPWDLogin}>
          <span >{t("确定")}</span>
        </div>
        {showH5LoginOptions && (
          <H5LoginOptions
            loginTextKey="验证码登录"
            loginIconType="icon-yanzhengmadenglu"
            onLoginSwitch={switchToVerificationLogin}
            onWechatLogin={onWechatLogin}
          />
        )}
      </div>
    </div>)
}
